import { toast } from 'react-hot-toast';
import { dmApi } from "../../app/dmApi";
import { getAuthorizationHeader, handleQueryErrorAndSuccess, handleToastMessage } from "../../helpers/RtkQueryUtils";

const authApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        loginUser: build.mutation({
            query: (request) => ({
                url: "/login",
                method: "POST",
                body: request,
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                queryFulfilled.then(res => {

                }).catch(error => {
                    handleToastMessage(error);
                    // toast("invaid");
                    // toast(error?.error?.data?.message, "error");
                })
            }
        }),
        forgotPassword: build.mutation({
            query: (request) => {
                return {
                    url: `/forgot-password`,
                    method: 'POST',
                    body: request,
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "", "A password reset email has been sent to the specified email address, if there is a user associated with it")
            },
        }),
        resetPassword: build.mutation({
            query: (request) => ({
                url: "/reset-password",
                method: "POST",
                body: request,
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                queryFulfilled.then(res => {
                }).catch(error => {
                    // toast(error?.error?.data?.message, "error");
                    handleToastMessage(error);
                })
            }
        }),
        updatePassword: build.mutation({
            query: (request) => ({
                url: "/update-password",
                method: "POST",
                body: request,
                headers: getAuthorizationHeader()
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                queryFulfilled.then(res => {
                }).catch(error => {
                    // toast(error?.error?.data?.message, "error");
                    handleToastMessage(error);
                })
            }
        }),
        updateTimezone: build.mutation({
            query: (request) => ({
                url: "/update-timezone",
                method: "POST",
                body: request,
                headers: getAuthorizationHeader()
            }),
        }),
    })
})
export const {
    useLoginUserMutation,
    useResetPasswordMutation,
    useForgotPasswordMutation,
    useUpdatePasswordMutation,
    useUpdateTimezoneMutation
} = authApi;